$(document).ready(function () {
  
    $('body').on("click",".text_above_on_video, .content-span",function(e){
      var video = $(this).closest('.mobile-banner').find('video')[0];
      if(video != null){
        if(video.paused){
          video.controls=false;
          video.loop=true;
          video.autoplay=true;
          video.muted=true;
          video.currentTime=0;
          video.play();
        }
      }
    });

  

  

       $('body').on("click",'.add_product_list_grid [data-add-to-cart]',function(ev){
          ev.preventDefault();
            var form = $(this).closest('form');
            var id = form.find('[name="id"]').val();
        $(this).find('[data-add-to-cart-text]').addClass('hide');
          $(this).find('[data-loader]').removeClass('hide');
          $('.cartdrawer .empty').hide();
          var properties = {};

          if (sessionStorage.getItem('glove_page') === 'true') {
            properties._glove_page = 'true';
          }

          if (sessionStorage.getItem('glof_page') === 'true') {
            properties._golf_page = 'true';
          }

          if (sessionStorage.getItem('mat_page') === 'true') {
            properties._mat_page = 'true';
          }
              
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {id:id,quantity:1,properties: properties},
              dataType: 'json',
              error: function(jqXHR, textStatus, errorThrown){
                var response = $.parseJSON(jqXHR.responseText);
                
                var desc = response.description;
                if(desc.indexOf(' to the cart.') != -1){
                  var ptitle = desc.replace('to the cart.','');
                  var optitle = ptitle.replace("You can't add more","").split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
                }else if(desc.indexOf("' is already sold out.") != -1){
                  var ptitle = desc.replace("' is already sold out.","");
                  var optitle = ptitle.replace("The product '","").split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +' to your cart due to our limited inventory at this time.');
                }else if(desc.indexOf("are in your cart.") != -1){
                  var ptitle = desc.replace('are in your cart.','');
                  var optitle = ptitle.replace('All','').split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
                }
                $('[data-add-to-cart-text]').removeClass('hide');
              $('[data-loader]').addClass('hide');
              $('.cartdrawer_loader').removeClass("show");
              },success: function(data){
                if(document.querySelector('body').classList.contains('template-product')){
                  var current_list_id = 'Similar Products';
                }else if(document.querySelector('body').classList.contains('template-index')){
                  var current_list_id = 'Home Page';
                }else if(document.querySelector('body').classList.contains('template-collection')){
                  var current_list_id = 'Collection Page';
                }else if(document.querySelector('body').classList.contains('template_how_to_use')){
                  var current_list_id = 'How To Use Page';
                } else if(document.querySelector('body').classList.contains('template_wipes') ||  document.querySelector('body').classList.contains('template_game_pages') || document.querySelector('body').classList.contains('template_edge')  || document.querySelector('body').classList.contains('template_new_game_page')  || document.querySelector('body').classList.contains('template_black_friday_bogo')  || document.querySelector('body').classList.contains('template_black_friday_football_bogo')   || document.querySelector('body').classList.contains('template_black_friday_wipes') || document.querySelector('body').classList.contains('template_girlsrule') || document.querySelector('body').classList.contains('template_boxing') || document.querySelector('body').classList.contains('template_black_friday') || document.querySelector('body').classList.contains('template_black_friday_early_access')  || document.querySelector('body').classList.contains('.template_new_glof_page') || document.querySelector('body').classList.contains('template_new_glove_page')){
                  var current_list_id = 'Home Page';     
                } else {
                  var current_list_id = 'Home Page';
                }
                add_track_event(data,current_list_id);
              }
            }).done(function( data ) {
              
             if(window.checkAndApplyFreeItem != null) { 
              window.checkAndApplyFreeItem();
             }

          $('.cartdrawer_loader').addClass("show");
          $('body').addClass('open-cart'); 
              $('[data-add-to-cart-text]').removeClass('hide');
              $('[data-loader]').addClass('hide');


              if(window.checkAndApplyFreeItem == null) { 
                $.getJSON("/cart", function(data) {
                  $('[data-cart-count]').text(data.item_count);
                });
                fetch(`${window.Shopify.routes.root}pages/page-for-cartdrawer`)
                .then(response => response.text())
                .then(data => {
                  if ($(data).find('.empty').length == 1 || $('.cartdrawer .empty').length == 1) {
                    $('.cartdrawer').html($(data).find('.cartdrawer').html());
                  } else {
                    $('.cartdrawer .cartdrawer-footer').html($(data).find('.cartdrawer-footer').html());
                    $('.cartdrawer .header').html($(data).find('.header').html());
                    if ($(data).find('.items .item').length == 1) {
                      $('.cartdrawer .cartdrawer-upsell').addClass('setfull');
                    } else {
                      $('.cartdrawer .cartdrawer-upsell').removeClass('setfull');
                    }
                    $('.cartdrawer .cartdrawer-upsell').html($(data).find('.cartdrawer-upsell').html());
                    $('.cartdrawer [data-cart_rows]').html($(data).find('[data-cart_rows]').html());
                    $('.cartdrawer .cartdrawer-announcements').html($(data).find('.cartdrawer-announcements').html());
                  }
                  
                  if(window.checkAndApplyFreeItem == null) {
                    $('.cartdrawer_loader').removeClass("show");
                  }
                  
                  window.lockScroll();
                  
                })
                .catch(error => console.error('Error fetching data:', error));
              }
            });
      });
   

     $('body').on("click", '.product-single #add-to-cartform [data-add-to-cart]', function(ev) {
        ev.preventDefault();
          var _this = $(this);
          console.log(_this);
          var form = _this.closest('#add-to-cartform').serialize();
          _this.find('[data-add-to-cart-text]').addClass('hide');
          _this.find('[data-loader]').removeClass('hide');
          $('.cartdrawer .empty').hide();
           var properties = [];

          if (sessionStorage.getItem('glove_page') == 'true') {
            properties.push('properties[_glove_page]=true');
          }

          if (sessionStorage.getItem('glof_page') == 'true') {
            properties.push('properties[_golf_page]=true');
          }

          if (sessionStorage.getItem('mat_page') == 'true') {
            properties.push('properties[_mat_page]=true');
          }

          if (properties.length > 0) {
            form += '&' + properties.join('&');
          }

          console.log(form);

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: form,
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown){
              var response = $.parseJSON(jqXHR.responseText);
              var desc = response.description;
              if(desc.indexOf(' to the cart.') != -1){
                var ptitle = desc.replace('to the cart.','');
                var optitle = ptitle.replace("You can't add more","").split(' - ');
                alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
              }else if(desc.indexOf("' is already sold out.") != -1){
                var ptitle = desc.replace("' is already sold out.","");
                var optitle = ptitle.replace("The product '","").split(' - ');
                alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +' to your cart due to our limited inventory at this time.');
              }else if(desc.indexOf("are in your cart.") != -1){
                var ptitle = desc.replace('are in your cart.','');
                var optitle = ptitle.replace('All','').split(' - ');
                alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
              }
              $('[data-add-to-cart-text]').removeClass('hide');
              $('[data-loader]').addClass('hide');
              $('.cartdrawer_loader').removeClass("show");
            },success: function(data){
              var current_list_id='Product Page'
                add_track_event(data,current_list_id);
              }
          }).done(function( data ) {
            
            if(window.checkAndApplyFreeItem != null) { 
              window.checkAndApplyFreeItem();
             }

            $('.cartdrawer_loader').addClass("show");
            $('body').addClass('open-cart');
            
            $('[data-add-to-cart-text]').removeClass('hide');
            $('[data-loader]').addClass('hide');
            
            if(window.checkAndApplyFreeItem == null) { 
              $.getJSON("/cart.js", function(data) {
                $('[data-cart-count]').text(data.item_count);
              });
              fetch(`${window.Shopify.routes.root}pages/page-for-cartdrawer`)
              .then(response => response.text())
              .then(data => {
                if ($(data).find('.empty').length == 1 || $('.cartdrawer .empty').length == 1) {
                  $('.cartdrawer').html($(data).find('.cartdrawer').html());
                } else {
                  $('.cartdrawer .cartdrawer-footer').html($(data).find('.cartdrawer-footer').html());
                  $('.cartdrawer .header').html($(data).find('.header').html());
                  if ($(data).find('.items .item').length == 1) {
                    $('.cartdrawer .cartdrawer-upsell').addClass('setfull');
                  } else {
                    $('.cartdrawer .cartdrawer-upsell').removeClass('setfull');
                  }
                  $('.cartdrawer .cartdrawer-upsell').html($(data).find('.cartdrawer-upsell').html());
                  $('.cartdrawer [data-cart_rows]').html($(data).find('[data-cart_rows]').html());
                  $('.cartdrawer .cartdrawer-announcements').html($(data).find('.cartdrawer-announcements').html());
                }
                if(window.checkAndApplyFreeItem == null) {
                  $('.cartdrawer_loader').removeClass("show");
                }
                
                window.lockScroll();
              })
              .catch(error => console.error('Error fetching data:', error));
            } 
          });
      });

  

    if($('.animatable').length > 0){
      var animation = function () {
        var s = $(window).scrollTop() + $(window).height(),
            all_animatable = $(".animatable");
        
        if (all_animatable.length == 0) {
            $(window).off("scroll", animation);
        }
        all_animatable.each(function(index,val) {
          var val_div = $(val);
          if(val_div.offset().top + val_div.height() - 160 < s){
            val_div.removeClass("animatable").removeClass('moveUp').addClass("animated");
          }
        });
    };
      $(window).on("scroll", animation);
      $(window).trigger("scroll");
    }

  var isScrolling;

  function check_button(){
        if($(window).width() < 750 && $('.shop-collection.add_product_list_grid').length > 0 && $('body').hasClass('template_edge') == true){
  
        var shop_collection = $('.shop-collection.add_product_list_grid').offset().top - $('#press_section').height() - 132;
        
          var scroll = $(window).scrollTop() + $('.shopify-section-header_vm').height();
          var elemBottom = $('.review_caurosal').offset().top;
          // var elemBottom = shop_collection + $('.shop-collection.add_product_list_grid').height() - $('.shop-collection.add_product_list_grid li.grid__item:last').height() + 125 + $('.shop-collection.add_product_list_grid li.grid__item:last .price_group_name').height();
  
          if (($(window).scrollTop()+$(window).height() <= elemBottom - 8) && (scroll > shop_collection)) {
            if($('.custom_popup_button_wrp').hasClass('first_time')){
              $('.custom_popup_button_wrp').removeClass('first_time');
              setTimeout(function(){
                $(".custom_popup_button_wrp").addClass("show_button");
              },200);
            } else{ 
              $(".custom_popup_button_wrp").addClass("show_button");
            }
          } else{
            $(".custom_popup_button_wrp").removeClass("show_button");
          } 
      } else if($(window).width() < 750 && $('.shop-collection.add_product_list_grid').length > 0 && $('body').hasClass('template_edge') == false){
            var shop_collection = $('.shop-collection.add_product_list_grid').offset().top - 10;
        
          var scroll = $(window).scrollTop() + $('header').height() + $('.announcement-bar').height() ;
          var elemBottom_below = shop_collection + $('.shop-collection.add_product_list_grid').height();
          var elemBottom = shop_collection + $('.shop-collection.add_product_list_grid').height() - ($('.shop-collection.add_product_list_grid li.grid__item:last .banner_block_wrp').length > 0 ? $('.shop-collection.add_product_list_grid li.grid__item:last .banner_block_wrp').height() : $('.shop-collection.add_product_list_grid li.grid__item:last .price_group_name').height()) - 57 - ($('.shop-collection.add_product_list_grid li.grid__item:last .price_group_name').length == 0 && ($('.shop-collection.add_product_list_grid li.grid__item:last .banner_block_wrp').length > 0 ? $('.shop-collection.add_product_list_grid li.grid__item:last .banner_block_wrp').height() - 450 : $('.shop-collection.add_product_list_grid li.grid__item:last .price_group_name').height() * 2));

          if ($('.custom_button_below_pro_list').is(':visible')){
            elemBottom_below -= $('.custom_button_below_pro_list').height(); 
            elemBottom -= $('.custom_button_below_pro_list').height();   
          }


          if ((($(window).scrollTop() + $('header').height() + $('.announcement-bar').height() - 15) < elemBottom) && (scroll > shop_collection)) {
            $(".custom_popup_button_wrp.in_header").slideDown(100);
          } else{
            $(".custom_popup_button_wrp.in_header").slideUp(100);
          }

      } else{
        $(".custom_popup_button_wrp").removeClass("show_button");
      }
  }
  
  $(window).on("scroll",function(){

    if($('.custom_popups:not(.inside_popup)').hasClass("active_popup")){
    $('.custom_popups').removeClass("active_popup");
    setTimeout(function(){
      $('.custom_popups').removeClass("formula_only_popup");
      $('.learnmore_product_wrp .keep__shopping_close').show();
    },2000);
    if($('.custom_popups').find('.image_text_card__video').length > 0){
         $('.custom_popups').find('.image_text_card__video').each(function(index, val){
           var video = $(val)[0];
            if(video != null){
                video.stop(); 
            }
         });
     }
    }

    clearTimeout(isScrolling);
    if($('.custom_popup_button_wrp').hasClass('first_time')){
      isScrolling = setTimeout(function() {
       check_button();         
      },300);
    } else{
      check_button();
    }
    
  });

   document.getElementById("mobile-nav-wrapper").style.setProperty("--header_height", document.getElementById("header").offsetHeight + "px");
    window.addEventListener("load", function () {
        document.getElementById("mobile-nav-wrapper").style.setProperty("--header_height", document.getElementById("header").offsetHeight + "px");
    });

    function margin_top(){
      var height = $('div#header').outerHeight();
      if ($('.custom_popup_button_wrp.in_header').is(':visible')){
        height -= $('.custom_popup_button_wrp.in_header').outerHeight();
      }
      $('div#PageContainer').css("margin-top",height);
  }
  margin_top();
  $(window).on("load, resize",function(){
    margin_top();
    check_button();
  });

  if($(".shopify-feature-row--section").length >  0){
     $(".shopify-feature-row--section").each(function (index) {
      $(this).addClass("shopify-feature-row-" + (index + 1));
    });
  }

  if($(".slider-for2").length > 0){
    $(".slider-for2").slick({infinite:true,slidesToShow:1,slidesToScroll:1,arrows:false,autoplay:true,autoplaySpeed:6000});
  }
  
    function add_track_event(data,current_list_id="Home page"){
      // console.log(data);
      //     var currency = document.querySelector('body').getAttribute('data-currency');
      //     gtag("event", "custom_add_to_cart", {
      //        send_to:[
      //         "G-C2R2CG5Z6T",
      //         "AW-304005457/SGbBCOrKqrcDENGC-5AB"
      //       ],
      //       currency: currency,
      //       value: data.price,
      //       location_id: current_list_id,
      //       items: [
      //         {
      //           item_id: data.id,
      //           item_name: data.title,
      //           affiliation: data.product_type,
      //           discount: data.total_discount,
      //           index: 0,
      //           item_brand: data.vendor,
      //           item_category: data.vendor,
      //           item_list_id: current_list_id,
      //           item_list_name: current_list_id,
      //           item_variant: data.variant_title,
      //           price: data.price,
      //           quantity: data.quantity
      //         }
      //       ]
      //     });
        }


  
//   $('[data-class] .jdgm-widget.jdgm-preview-badge').on("click",function(e){
//     e.preventDefault();
//     $('.'+$(this).parent().attr("data-class")).addClass("active");
// });
  
   $('body').on("click",".custom_review_popup:not(.custom_review_popup_learn_more)",function(event){
      event.stopPropagation();
      event.preventDefault();
      $('#product_review_popup').addClass("active");
      window.lockScroll();
});

$('body').on("click",".product_review_popup .close_icon",function(e){
    e.preventDefault();
    $(this).closest(".product_review_popup").removeClass("active");

  if($('.learn_more_popup.active').length == 0) {
    window.unlockScroll();
  }
});

$('body').on('click', function(e) {
  if ($(e.target).closest('.product_review_popup .product_review_popup_wrp').length === 0 && $('.product_review_popup').hasClass('active')) {
    $('.product_review_popup').removeClass('active');
    if($('.learn_more_popup.active').length == 0) {
      window.unlockScroll();
    }
  }
});



      $('body').on("click",".site-nav--has-dropdown",function(e){
      e.preventDefault();
      if($(this).hasClass("site-nav--active-dropdown")){
        $(this).removeClass("site-nav--active-dropdown");
      } else {
        $('.site-nav--has-dropdown').removeClass("site-nav--active-dropdown");
        $(this).addClass("site-nav--active-dropdown");
      }
    });
     


 $('body').on('click', '.cartdrawer-close,.cartdrawer-overlay', function(e) {
    e.preventDefault();
    $('body').removeClass('open-cart');
    if($('.cartdrawer .items').length > 0){
      $('.cartdrawer .items').get(0).scrollTo(0,0);
    }
    window.unlockScroll();
  });
  function cartrefresh(data){
    $.getJSON("/cart", function(data) {
      
      $('[data-cart-count]').text(data.item_count);
    });
    fetch(`${window.Shopify.routes.root}pages/page-for-cartdrawer`)
    .then(response => response.text())
    .then(data => {
      if ($(data).find('.empty').length == 1 || $('.cartdrawer .empty').length == 1) {
        $('body .cartdrawer').html($(data).find('.cartdrawer').html());
      } else {
        $('body .cartdrawer .cartdrawer-footer').html($(data).find('.cartdrawer-footer').html());
        $('body .cartdrawer .header').html($(data).find('.header').html());
        if ($(data).find('.items .item').length == 1) {
          $('body .cartdrawer .cartdrawer-upsell').addClass('setfull');
        } else {
          $('body .cartdrawer .cartdrawer-upsell').removeClass('setfull');
        }
        $('body .cartdrawer .cartdrawer-upsell').html($(data).find('.cartdrawer-upsell').html());
        $('body .cartdrawer [data-cart_rows]').html($(data).find('[data-cart_rows]').html());
        $('body .cartdrawer .cartdrawer-announcements').html($(data).find('.cartdrawer-announcements').html());
      }
      $('body').addClass('open-cart');
      $('.cartdrawer_loader').removeClass("show");
      if($('.cartdrawer .items').length > 0){
        $('.cartdrawer .items').get(0).scrollTo(0,0);
      }    
    })
    .catch(error => {
      console.error('Cart refresh failed:', error);
      $('.cartdrawer_loader').removeClass("show");
    });
  }
  window.cartrefresh = cartrefresh;

  $('body').on('click', '.cartdrawer .items .item .remove', function(e) {
    e.preventDefault();
    var id = $(this).parents('.item').attr('data-line-item-key');
    $('.rc_popup').attr('data-line-item-id',id);
    $('body').addClass('open_rc_popup');
  });
  $('body').on('click', '.remove_confirm', function(e) {
    e.preventDefault();
    var id = $(this).parents('.rc_popup').attr('data-line-item-id');
    $('body').removeClass('open_rc_popup');
    $('.cartdrawer_loader').addClass("show");
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {id:id,quantity:0},
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('.cartdrawer_loader').removeClass("show");
      }
    }).done(function( data ) {
      
      if(window.checkAndApplyFreeItem != null) { 
        window.checkAndApplyFreeItem();
      }

      if(window.checkAndApplyFreeItem == null) {
        cartrefresh(data);
      }
    });
  });
  $('body').on('click', '.cartdrawer .items .item .quantity', function(e) {
    $('.cartdrawer_loader').addClass("show");
    console.log("sss");
    e.preventDefault();
    // var id = $(this).parents('.item').attr('data-variant-id');
    var id = $(this).parents('.item').attr('data-line-item-key');
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    var current_ip = parseInt(input.val());

   
    if($(this).hasClass('minus') && ip == 1){
      $(this).parents('.item').find('.remove').click();
    } else{
       if($(this).hasClass('plus')) {
        ip = ip + 1;
      } else {
        ip = ip - 1;
      }
      input.val(ip);
       

  
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {id:id,quantity:ip},
          async: false,
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            var desc = response.description;
            input.val(current_ip);
            if(desc.indexOf(' to the cart.') != -1){
              var ptitle = desc.replace('to the cart.','');
              var optitle = ptitle.replace("You can't add more","").split(' - ');
              alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
            }else if(desc.indexOf("' is already sold out.") != -1){
              var ptitle = desc.replace("' is already sold out.","");
              var optitle = ptitle.replace("The product '","").split(' - ');
              alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +' to your cart due to our limited inventory at this time.');
            }else if(desc.indexOf("are in your cart.") != -1){
              var ptitle = desc.replace('are in your cart.','');
              var optitle = ptitle.replace('All','').split(' - ');
              alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
            }
            $('.cartdrawer_loader').removeClass("show");
          }
        }).done(function( data ) {
          if(window.checkAndApplyFreeItem != null) { 
              window.checkAndApplyFreeItem();
             }

          if(window.checkAndApplyFreeItem == null) {
            cartrefresh(data);
          }
          if($('.cartdrawer .items').length > 0){
            $('.cartdrawer .items').get(0).scrollTo(0,0);
          }    
        }); 

    }
  });
  $('body').on('click', '[name="checkout"]', function(e) {
    localStorage.setItem("last_url", window.last_url);
    $('.cartdrawer_loader').addClass("show"); 
  });
  $('body').on('click', '.upsell-list .price-button button', function(e) {
    e.preventDefault();
    var id = $(this).parents('.upsell-item').attr('data-id');
    $('.cartdrawer_loader').addClass("show");
     var properties = {};

          if (sessionStorage.getItem('glove_page') === 'true') {
            properties._glove_page = 'true';
          }

          if (sessionStorage.getItem('glof_page') === 'true') {
            properties._golf_page = 'true';
          }

          if (sessionStorage.getItem('mat_page') === 'true') {
            properties._mat_page = 'true';
          }
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id:id,quantity:1,properties: properties},
      dataType: 'json',
      async: false,
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('.cartdrawer_loader').removeClass("show");
      },success: function(data){
        var current_list_id='Upsell';
        add_track_event(data,current_list_id);
      }
    }).done(function( data ) {
      if(window.checkAndApplyFreeItem != null) { 
        window.checkAndApplyFreeItem();
      }
      
      if(window.checkAndApplyFreeItem == null) {
        cartrefresh(data);
      }
      if($('.cartdrawer .items').length > 0){
        $('.cartdrawer .items').get(0).scrollTo(0,0);
      }    
    });
   
  });
  $('body').on('click','.remove_upsell',function(e){
    e.preventDefault();
    $('body').addClass('hide_upsell');
  });
  $('body').on('click', '.close_rc_popup,.rc_overlay', function(e) {
    e.preventDefault();
    $('body').removeClass('open_rc_popup');
    $('.cartdrawer_loader').removeClass("show"); 
  });
  

   if($('.review_caurosals').length > 0){
    $(".review_caurosals").slick({
      slidesToShow: 3.1,
      slidesToScroll: 1,
      infinite: true,
      speed: 100,
      swipeToSlide: true,
      waitForAnimate: false,
      touchThreshold: 100,
      centerMode: false,
      arrows: true,
      cssEase: 'linear',
      variableWidth: false,
      autoplay: $('.review_caurosals').attr("data-autoplay") == 'false'? false : true,
      autoplaySpeed: $('.review_caurosals').attr("data-autoplay_speed"),
      dots: true,
      appendDots: $('.review_caurosals_slick_buttons .caurosal_dots'),
      prevArrow: $('.review_caurosals_slick_buttons .prev_button'),
      nextArrow: $('.review_caurosals_slick_buttons .next_button'),
      responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.2
        }
      }
    ]
    });
     $('.review_caurosals_slick_buttons .caurosal_dots ul.slick-dots li').css("width",($('.review_caurosals_slick_buttons .caurosal_dots').width()/$('.review_caurosal_card').length)+"px");
  }

$("body").on("click",".set > span", function () {
    $(this).hasClass("active")
      ? ($(this).removeClass("active"),
        $(this).siblings(".content").slideUp(200),
        $(".set > span i").removeClass("fa-minus").addClass("fa-plus"))
      : ($(".set > span i").removeClass("fa-minus").addClass("fa-plus"),
        $(this).find("i").removeClass("fa-plus").addClass("fa-minus"),
        $(".set > span").removeClass("active"),
        $(this).addClass("active"),
        $(".content").slideUp(200),
        $(this).siblings(".content").slideDown(200));
  });
  $("body").on("click",".faqbtn", function () {
      $(".faqbtn").toggleClass("active"), $(".togglecontainer").slideToggle();
  });

  if($(".slider1").length > 0){
    var slick_settings = {
        dots: !0,
        infinite: !1,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: !0,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: !0,
            },
          },
        ],
      };
    if($(window).width() < 768){
      $(".slider1").slick(slick_settings);
    }
     $(window).on("resize orientationchange load", function () {
       if($(window).width() >= 768){
         if($(".slider1").hasClass('slick-initialized')){
           $(".slider1").slick("unslick");
         } 
       } else{
         $(".slider1").not('.slick-initialized').slick(slick_settings);
         $(".slider1").slick("refresh");
       }
     });
  }

  
// if ($('.theridge-promoBanner__text').length > 1) {
//   var bannerFlip = document.querySelector(".theridge-promoBanner__wrapper");
//   var bannerTextNumber = document.getElementsByClassName("theridge-promoBanner__text").length;

//   var bannerSize = 44.5;

//   if ($(window).width() < 768) {
//     bannerSize = 38;
//   }
//   var firstBannerClone = document.querySelector(".theridge-promoBanner__text").cloneNode(true);
//   bannerFlip.appendChild(firstBannerClone);

//   var currentPosition = 0;
//   var totalHeight = bannerSize * bannerTextNumber;

//   var bannerFlipInterval = setInterval(() => {
//     currentPosition -= bannerSize; 
//     bannerFlip.style.transition = "transform 0.5s ease";
//     bannerFlip.style.transform = `translateY(${currentPosition}px)`;

//     if (Math.abs(currentPosition) >= totalHeight) {
//       setTimeout(() => {
//         bannerFlip.style.transition = "none";
//         currentPosition = 0;
//         bannerFlip.style.transform = `translateY(${currentPosition}px)`;
//       }, 500); 
//     }
//   }, 3000);
// }

var promoWrappers = document.querySelectorAll(".announcement-bar--wrp .theridge-promoBanner__wrapper");

promoWrappers.forEach(wrapper => {
  if (window.getComputedStyle(wrapper).display === "block") {
    var bannerTextNumber = wrapper.getElementsByClassName("theridge-promoBanner__text").length;

    if (bannerTextNumber < 2) {
      return;
    }
    var bannerSize = 44.5;

    if ($(window).width() < 768) {
      bannerSize = 38;
    }

    var firstBannerClone = wrapper.querySelector(".theridge-promoBanner__text").cloneNode(true);
    wrapper.appendChild(firstBannerClone);

    var currentPosition = 0;
    var totalHeight = bannerSize * bannerTextNumber;

    wrapper.style.overflow = "hidden";

    var bannerFlipInterval = setInterval(() => {
      currentPosition -= bannerSize; 
      wrapper.style.transition = "transform 0.5s ease";
      wrapper.style.transform = `translateY(${currentPosition}px)`;

      if (Math.abs(currentPosition) >= totalHeight) {
        setTimeout(() => {
          wrapper.style.transition = "none";
          currentPosition = 0;
          wrapper.style.transform = `translateY(${currentPosition}px)`;
          setTimeout(() => {
            wrapper.style.transition = "transform 0.5s ease";
          }, 50); 
        }, 500); 
      }
    }, 4000);
  }
});


  
document.querySelectorAll('.review_caurosal_card').forEach(wrapper => {
  const desc = wrapper.querySelector('.review_caurosal_desc');
  const readMore = wrapper.querySelector('.read-more_review');

  const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
  const maxHeight = lineHeight * 7;

  if (desc.scrollHeight > maxHeight + 2) {
    readMore.style.display = 'inline';
  } else {
    readMore.style.display = 'none';
  }

  readMore.addEventListener('click', function(e) {
    e.preventDefault();

    const isExpanded = desc.classList.toggle('expanded');
    readMore.textContent = isExpanded ? window.less_text : window.more_text;
  });
 
});

 $(window).on("resize",function() {
    document.querySelectorAll('.review_caurosal_card').forEach(wrapper => {
  const desc = wrapper.querySelector('.review_caurosal_desc');
  const readMore = wrapper.querySelector('.read-more_review');

  const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
  const maxHeight = lineHeight * 7;

  if (desc.scrollHeight > maxHeight + 2) {
    readMore.style.display = 'inline';
  }  else {
    readMore.style.display = 'none';
  }
    });
});


if (navigator.appVersion.indexOf('Mac') >= 0) {
  $('body').addClass("mac");
} else {
  $('body').addClass("window");
}

  
$('body').on("click",".js_learnmore",function(e){
  e.preventDefault();
  var _this = $(this);
  var review_ratings = _this.next('.reviews_html_count').html();
  var url = $(this).attr("href");
  // document.querySelector('.learnmore_loader').style.display="flex";
  document.querySelector('.learnmore_loader').classList.add('show_loader');
  
  if(!$('body').hasClass('lock-scroll')) {
    window.lockScroll();
  }
  
  $('body').addClass("no_alia_popup");
  $('.learmore_product #ProductJson').remove();
  $('.learmore_product #ProdcutMetafields').remove();
  $('.learmore_product').html(" ");

  window.first_time_open = true;
  window.first_time_open_review = true;

  var learn_more_template = $(this).attr("data-template") || 'learn_more';
  var has_view = /[?&]view=/.test(url);
  var fetch_url = has_view ? url : `${url}&view=${learn_more_template}`;

  $.get(fetch_url, function(inner_images_html){
    var inner_images = inner_images_html;
    
    if (has_view) {
      var $inner = $(inner_images_html);
      inner_images = $inner.find('.append_images').html() || '';
    }

    $.get(url, function(html){

      var pid = $(html).find('.product_temp').attr("data-product_id");
      
      localStorage.setItem('popup_open_quick', 'true');

      if(inner_images && $(html).find('.append_images').length > 0){
        // alert(" inner_images ");
        $(html).find('.append_images').html(inner_images);
      }
      if ($(html).find('.js_main_product_wrp').length > 0) {
        if ($(html).find('.js_main_product_wrp').find(".pdp_append_data").length > 0) {
          $('.learmore_product').html($(html).find('.js_main_product_wrp').find(".pdp_append_data").html().replaceAll('custom_review_popup','custom_review_popup custom_review_popup_learn_more'));
        }
      }
      
      if(inner_images){
        $('.learmore_product .append_images').html(inner_images);
      }

      $('.learmore_product .product_temp').find('.custom_review_popup').html(review_ratings);

      document.querySelector('.learmore_product').scrollTo(0, 0);
      document.querySelector('.learmore_product_wrp').scrollTo(0, 0); 
      window.minus_pos = 0;
      if (url.indexOf('/products/sneaker-sole-grip-bundles?variant=42846654398616') == -1 && url.indexOf('/products/sneaker-sole-grip-bundles') > -1) {
        window.minus_pos = 1;
      }
      window.currentIndex = 0;
      window.mobile_image_load();
      window.load_change();
      window.image_height();
      window.load_time = true;
      window.change_name_id();

      window.all_observes();

      window.renderIndicator();

       const intervalID = setInterval(imagechange, 10);
    var timesRun = 0;
    var imagechange = setInterval(function () {
        timesRun += 1;
        if (timesRun === 10) {
            clearInterval(imagechange);
        }
        var img = document.querySelector(".learmore_product img.product-single__thumbnail-image:not(.with_video)"),
            height = img ? img.parentNode.clientHeight + "px" : "100%",
            videoImages = document.querySelectorAll(".learmore_product .with_video.product-single__thumbnail-image");
        videoImages.length > 0 &&
            videoImages.forEach(function (e) {
                e.style.height = height;
            });
             document.querySelectorAll(".learmore_product [data-slider-item] img").forEach(function(e){
              e.style.height = height;
            });
    }, 10);

      var scroll_wrp_l = document.querySelector(".learmore_product .scroll-wrap_mob .scroll-wrap"), o;

      $('.learmore_product .scroll-wrap_mob .scroll-wrap').scroll(function(){
        clearTimeout(o);
              o = setTimeout(function () {
                  var activeElement = document.querySelector(".learmore_product .scroll-wrap_mob.main_mob #indicator .active").parentElement;
                  var currentIndex = Array.from(activeElement.parentElement.children).indexOf(activeElement) + 1;
                  var totalItems = document.querySelectorAll(".learmore_product .scroll-wrap_mob.main_mob .scroll-wrap li:not(.hide_var)").length;
                  var nextArrow = document.querySelector(".learmore_product .scroll-wrap_mob.main_mob .arrow_next");
                  var prevArrow = document.querySelector(".learmore_product .scroll-wrap_mob.main_mob .arrow_prev");
      
                  nextArrow.style.display = "block";
                  prevArrow.style.display = "block";
      
                  if (currentIndex >= totalItems) {
                      nextArrow.style.display = "none";
                  }
      
                  if (currentIndex < 2) {
                      prevArrow.style.display = "none";
                  }
                $('.learmore_product .media-video').each(function(index, val) {
                  var v = $(val)[0];
                  if(v != null){
                  if (!v.paused) {
                    // if(!v.classList.contains('learnmore_video_mob')){}
                      v.pause();
                      v.controls=false;
                      v.loop=true;
                      v.autoplay=false;
                      v.muted=true;
                      // if(!v.classList.contains('learnmore_video_mob')){}
                      v.currentTime=0; 
                    }
                  }
                  $(val).next().css("display", "flex");

                });
                $('.learmore_product .main_mob').find('.product_media_button').css("display", "flex");
                var video = document.querySelectorAll('.learmore_product .main_mob .scroll-wrap > li:not(.hide_var)')[currentIndex-1].querySelector('video');
                $(document.querySelectorAll('.learmore_product .main_mob .scroll-wrap > li:not(.hide_var)')[currentIndex-1]).find('.product_media_button').css("display", "flex")

              var visibleItem = document.querySelectorAll('.learmore_product .main_mob .scroll-wrap > li:not(.hide_var)')[currentIndex - 1];
              var imgHeight = $(visibleItem).find('img').height() || $(visibleItem).find('video').height();
              var imgWidth = $(visibleItem).find('img').width() || $(visibleItem).find('video').width();

              var containerWidth = visibleItem.offsetWidth;
              var newHeight = (imgHeight / imgWidth) * containerWidth;

              console.log(imgHeight);
                document.querySelector(".learmore_product .scroll-wrap_mob .scroll-wrap").style.height = `${imgHeight}px`;
                if (imgHeight > 100) {
                  document.querySelector(".learmore_product .scroll-wrap_mob .scroll-wrap").style.minHeight = 'unset';
                }
              
              }, 10);
      });

    
        window.image_height();
        if(window.info_text != "" && window.info_text != undefined && window.info_text != null) {
          if($('.learmore_product .info_dis_text').length == 0){
            $('.learmore_product .select_option').after(`<p class='info_dis_text'>${window.info_text}</p>`);
          }
        }
        $('.learmore_product .product-single__thumbnails-item[data-slider-slide-index="-1"]').find('.product-single__thumbnail').click();
        $('.learmore_product #indicator li').find('span[data-index="1"]').closest('li').click();   
        
        var p_id = Number($('.learmore_product .product_temp').attr('data-product_id')); 

        if ((p_id == 6754115092632 || p_id == 7734929129624) && sessionStorage.getItem('glove_page') === 'true') {

          if (Shopify.locale == 'ko') {
            $('.learmore_product .product-single__description h3:visible').first()
            .html(`특허 출원 중인 <span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE®</span> 포뮬러로 축구 장갑의 그립감을 새것처럼 되살려보세요.`);

          }
          else if (Shopify.locale == 'ja') {
          $('.learmore_product .product-single__description h3:visible').first()
            .html(`当社の特許出願中の<span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE®</span>成分が、アメフトグローブを徹底的に洗浄し、グリップ力を回復させます。`);
         }else{
            $('.learmore_product .product-single__description h3:visible').first()
            .html(`Our patent-pending <span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE® Formula</span> deep cleans and regrips football gloves.`);

         } 


        } 
        else if (p_id == 7728439034008 && sessionStorage.getItem('glove_page') === 'true') {


          if (Shopify.locale == 'ko') {

             $('.learmore_product .product-single__description h3:visible').first()
          .html(`특허 출원 중인 <span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE®</span>, 포뮬러가 함유된 와이프로 축구 장갑을 깨끗하게 세정하고, 마모된 그립력을 새것처럼 복원시켜 보세요.`);
            

          } else if (Shopify.locale == 'ja') {
            $('.learmore_product .product-single__description h3:visible').first()
              .html(`当社の特許出願中の<span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE®成分</span>を配合したワイプが、アメフトグローブを徹底的に洗浄し、グリップ力を回復させます。`);
          }  else{

              $('.learmore_product .product-single__description h3:visible').first()
            .html(`Infused with our patent-pending <span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE® Formula</span>, our wipes deep clean and regrip football gloves.`);
            
          }
          

        } 
        else if (p_id == 7738116505752 && sessionStorage.getItem('glove_page') === 'true') {

          if (Shopify.locale == 'ko') {

            $('.learmore_product .product-single__description h3:visible').first()
            .html(`그립 스프레이와 그립 와이프를 동시에! 두 가지 제품이 선사하는 강력한 세정력과 탁월한 그립 복원력을 경험해 보세요.`);


          } else if (Shopify.locale == 'ja') {

              $('.learmore_product .product-single__description h3:visible').first()
                .html(`EDGE®のグリップスプレーとグリップワイプの両方を試せるお得なセットです。どちらの製品も、アメフトグローブの表面を徹底的に洗浄し、グリップ力が回復します。`);
            } else{

              $('.learmore_product .product-single__description h3:visible').first()
            .html(`Bundles come with both our Grip Spray and our Grip Wipes - use either to deep clean and regrip football gloves.`);


            }


          
              
        } 
        else if ((p_id == 6754115092632 || p_id == 7734929129624 || p_id == 7728439034008) && sessionStorage.getItem('golf_page') === 'true') {
          $('.learmore_product .product-single__description h3:visible').first()
            .html(`Deep cleans and rejuvenates your golf grips.`);
        }

        
        $('.learn_more_popup').addClass("active");
        
        document.querySelector('.learmore_product').scrollTo(0, 0);
        document.querySelector('.learmore_product_wrp').scrollTo(0, 0); 
        
        // if($('.learn_more_popup').find('.learnmore_video:not(.learnmore_video_mob)').length > 0) {
        //   if($('.learn_more_popup').find('.learnmore_video:not(.learnmore_video_mob)')[0].paused && $('.learn_more_popup').find('.learnmore_video:not(.learnmore_video_mob)')[0].currentTime == 0){
        //     $('.learn_more_popup').find('.learnmore_video:not(.learnmore_video_mob)')[0].play();
        //   }  
        // }
        // if($('.learn_more_popup').find('.learnmore_video_mob').length > 0) {
        //   if($('.learn_more_popup').find('.learnmore_video_mob')[0].paused && $('.learn_more_popup').find('.learnmore_video_mob')[0].currentTime == 0){  
        //     $('.learn_more_popup').find('.learnmore_video_mob')[0].play();
        //   }  
        // }
        document.querySelector('.learnmore_loader').classList.remove('show_loader');

    });

  });
});


   $('body').on("click",".learn_more_popup.active .close_icon, .learn_more_popup .overlay, .keep__shopping_close",function(e){
      e.preventDefault();
    if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.delete('variant'); 
        window.history.replaceState({}, document.title, url.toString());
    }


   $('.learn_more_popup').removeClass("active");
   $('.learmore_product').html(" ");

   $('body').removeClass("no_alia_popup");
   
   window.unlockScroll();
   
    if($('.learn_more_popup').find('video').length > 0){
         $('.learn_more_popup').find('video').each(function(index, val){
           var video = $(val);
            if(video != null){
                video.stop(); 
            }
         });
     }
     

  });

  document.addEventListener("click", function(event) {
  if (event.target.closest(".custom_review_popup.custom_review_popup_learn_more")) {
    event.stopPropagation();
      event.preventDefault();
      $('#custom_learn_more_judgme').addClass("active");
      if($('.learn_more_popup.active').length == 0) {
        window.lockScroll();
      }
  }
});

var target = document.querySelector(".judme_learn_more");
if (target) {
  var observer = new MutationObserver(() => {
    target.querySelectorAll("img[data-src]").forEach(img => {
      if (!img.src || img.src !== img.dataset.src) { 
        img.src = img.dataset.src;
      }
    });
    document.querySelectorAll(
  '.judme_learn_more .jdgm-sort-dropdown option[value="most-helpful"], .judme_learn_more .jdgm-sort-dropdown option[value="videos-first"]'
    ).forEach(opt => opt.remove());

  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
}

function scrollWhenIdle(callback, timeout = 200) {
    let timer;
    window.addEventListener("scroll", function() {
        clearTimeout(timer);
        timer = setTimeout(callback, timeout);
    }, { passive: true });
}

$("body").on("click", ".learmore_product_wrp .jdgm-paginate__page", function() {
    scrollWhenIdle(() => {
        document.querySelector(".learmore_product_wrp .jdgm-row-actions")?.scrollIntoView({ behavior: "smooth" });
    });
});

 
  //  var interval = setInterval(() => {
  //   var el = document.querySelector(".jdgm-rev-widg__body");
  //   if (el && el.getAttribute("style") && el.getAttribute("style").trim() !== "") {
  //     clearInterval(interval);
  //     document.querySelector(".jdgm-row-actions").scrollIntoView({ behavior: "smooth" });
  //   }
  // }, 300); 

    /* custom reviews: moved to custom_reviews.js and custom_reviews_{en,ko,ja}.js, loaded from layout/theme.liquid */


$('body').on('click','.desc-toggle', function() {
    const $toggle = $(this);
    const $content = $toggle.next('.desc-content');

    if ($toggle.hasClass('active')) {
      $content.slideUp(250);
      $toggle.removeClass('active');
    } else {
      $content.slideDown(250);
      $toggle.addClass('active');
    }
  });

 let countdownTimer = class extends HTMLElement {
  constructor() {
      super();
      console.log(this, this.querySelector('.countdown__timer'));
      var counttime = this.querySelector('.countdown__timer').dataset.timer;
      var countDownDate = new Date(counttime).getTime();
      var expired_msg  = this.querySelector('.countdown__datetime').dataset.expired_msg;

      var days = this.querySelector('[data-days]');
      var hours = this.querySelector('[data-hours]');
      var seconds = this.querySelector('[data-seconds]');
      var minutes = this.querySelector('[data-minutes]');
      var countdown = this.querySelector(".countdown__timer");
      var reset_hours = this.querySelector(".countdown__timer").dataset.reset_hours || null;

      document.querySelector('.timer_left_text').style.display = 'block';
      
      if (reset_hours != null) {
        function getNextResetTime() {
          const now = new Date();
          const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
          const msIn48Hours = parseFloat(reset_hours) * 60 * 60 * 1000;

          const lastReset = new Date(midnight.getTime() - (midnight.getTime() % msIn48Hours));
          let nextReset = new Date(lastReset.getTime() + msIn48Hours);

          if (nextReset < now) nextReset = new Date(nextReset.getTime() + msIn48Hours);
          return nextReset;
        }
      //  function getNextResetTime() {
      //     const now = new Date();
      //     const resetHours = {{ section.settings.reset_hours | times: 1 | plus: 0 }};
      //     const msInReset = resetHours * 60 * 60 * 1000;

      //     const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      //     const elapsedSinceMidnight = now.getTime() - midnight.getTime();
      //     const lastResetOffset = Math.floor(elapsedSinceMidnight / msInReset) * msInReset;

      //     const lastReset = new Date(midnight.getTime() + lastResetOffset);
      //     let nextReset = new Date(lastReset.getTime() + msInReset);

      //     if (nextReset <= now) nextReset = new Date(nextReset.getTime() + msInReset);

      //     return nextReset;
      //   }

        countDownDate = getNextResetTime().getTime();

        setInterval(() => {
          const now = new Date().getTime();
          const distance = Number(countDownDate) - Number(now);

          if (distance <= 0) {
            countDownDate = getNextResetTime().getTime();
            return;
          }

          const d = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
          const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
          const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
          const s = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');

          days.textContent = d;
          hours.textContent = h;
          minutes.textContent = m;
          seconds.textContent = s;
        }, 1000);
      } else {
        var x = setInterval(function() {
      
        var now = new Date().getTime();
      
        var distance = countDownDate - now;
      
        var d = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
        var h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
        var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
        var s = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');
      
        
        minutes.innerHTML = m;
        days.innerHTML = d;
        seconds.innerHTML = s;
        hours.innerHTML = h;
      
        if (distance < 0) {
          clearInterval(x);
          countdown.innerHTML = expired_msg;
          document.querySelector('.timer_left_text').style.display = 'none';
          if (expired_msg == '') {
            document.querySelector('.homw_timer').style.display = 'none';
          }
        }
      }, 1000);
    }
          
    }
  };

  customElements.get("countdown-timer") || customElements.define("countdown-timer", countdownTimer);  


});

document.addEventListener("contextmenu", function(e) {
    e.preventDefault();
  });


